<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import inventory_miAPI from "@/services/standards/inventory_mi/inventory_miAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ItemAPI from "@/services/items/itemsAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas, herramientas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas, herramientas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Administración de equipos, instalaciones, máquinas, herramientas",
          active: true,
        },
      ],

      lista: [],
      loading: true,

      item: null,

      itemData: null,

      inventory: {
        code: null,
        name: null,
        description: null,
        brand: null,
        model: null,
        maintenance_frequency_months: null,
        status: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      // Catálogo de periodicidades (config/maintenance.php del backend).
      frequencies: {},
      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(49)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 49)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    /** Catálogo de periodicidades de mantenimiento del backend. */
    getCatalogs() {
      inventory_miAPI.catalogs()
        .then((res) => {
          if (res) this.frequencies = res.frequencies || {};
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getInventory() {
      inventory_miAPI.getinventory_mi(this.$route.params.id)
        .then((response) => {
          this.inventory = {
            code: response.data.code,
            name: response.data.name,
            description: response.data.description,
            brand: response.data.brand,
            model: response.data.model,
            maintenance_frequency_months: response.data.maintenance_frequency_months,
            status: response.data.status,
            companies_id: response.data.companies_id
          };
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    update() {
      this.submitted = true
      this.loading = true
      inventory_miAPI.updateinventory_mi(this.$route.params.id, {
        code: this.inventory.code,
        name: this.inventory.name,
        description: this.inventory.description,
        brand: this.inventory.brand,
        model: this.inventory.model,
        status: this.inventory.status,
        companies_id: this.inventory.companies_id
      })
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 49,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Informacion actualizada con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                this.$router.go(-1);
              }, 2000)
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems()
    this.getCatalogs();
    this.getInventory();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Descargar el archivo con la matriz de IPEVR, realizar diligenciamiento de cada uno de los campos
                      correspondientes, para poder determinar los controles que se deberán implementar. Es necesario que
                      se cuente con la participación de todos los niveles de la organización en la identificación de
                      estos
                      peligros, se puede realizar por medio de capacitaciones, encuestas, inspecciones, entre otros.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">

                </div>

              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-6" label="Código" label-for="employee">
                    <b-form-input type="text" id="code" v-model="inventory.code" placeholder=""></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6" label="Nombre (Instalación, equipo, maquinaria, herramienta)"
                    label-for="employee">
                    <b-form-input type="text" id="name" v-model="inventory.name" placeholder=""></b-form-input>
                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group class="col-md-3" label="Marca" label-for="input-sm">
                    <b-form-input type="text" id="brand" v-model="inventory.brand" placeholder="">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Modelo" label-for="hora">
                    <b-form-input type="text" id="model" v-model="inventory.model" placeholder=""></b-form-input>
                  </b-form-group>
                  <!-- Periodicidad: base del cálculo del próximo mantenimiento y del semáforo. -->
                  <b-form-group class="col-md-3" label="Periodicidad de mantenimiento"
                    label-for="maintenanceFrequency">
                    <select id="maintenanceFrequency" class="form-control"
                      v-model="inventory.maintenance_frequency_months">
                      <option :value="null">Seleccione...</option>
                      <option v-for="(label, months) in frequencies" :key="months" :value="Number(months)">
                        {{ label }}
                      </option>
                    </select>
                    <small class="text-muted">Define cada cuánto vence el mantenimiento del activo.</small>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Estado" label-for="employee">
                    <select id="employeeID" class="form-control" v-model="inventory.status">
                      <b-form-select-option value="1">
                        Activo
                      </b-form-select-option>
                      <b-form-select-option value="0">
                        Inactivo
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Observaciones" label-for="input-sm">
                    <b-form-textarea id="description" v-model="inventory.description" rows="4"></b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>